import React, { useEffect, useState, useContext, useRef } from 'react'
import styled from 'styled-components'
import { PageHeaderTypeThree, BreakpointMobile } from '../Layout/GlobalStyle'
import withLocation from '../common/withLocation'
import { getHerbs } from '../../services/herb.services'
import { remedyTypes } from '../../utils/defaultJSON'
import Select from '@material-ui/core/Select';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import ListItemText from '@material-ui/core/ListItemText';

import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import RatingInput from '../common/RatingInput'
import { submitHerbReview, getReviewByHerbAndUserID } from '../../services/herb-review.services'
import ErrorsContext from '../../providers/ErrorsProvider'
import { getRemediesByHerbID } from '../../services/remedy.services'
import { getAilments } from '../../services/ailment.services'
import Chip from '@material-ui/core/Chip';
import Checkbox from '@material-ui/core/Checkbox';

import { FormHelperText, IconButton } from '@material-ui/core';
import Input from '@material-ui/core/Input';
import LoadingContainer from '../common/LoadingContainer'
import AddIcon from '@material-ui/icons/Add';
import Compressor from 'compressorjs';
import CloseIcon from '@material-ui/icons/Close';
import blobToBase64 from 'blob-to-base64'
import AuthUserContext from '../../providers/AuthProvider'
import { navigate } from "@reach/router"
import { SUBMITTED_HERB_REVIEW } from '../Layout/routes'

const useStyles = makeStyles((theme) => ({
    formControl: {
        minWidth: 120
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
    },
    photoGridRemove: {
        width: 20,
        height: 20,
        position: 'absolute',
        right: 5,
        fontSize: 11,
        top: 5,
        background: '#FFFFFF',
        boxShadow: '1px 1px 3px rgba(0,0,0,0.5)',
        '&:hover': {
            background: '#FFFFFF',

        }
    },
    addButton: {
        width: '100%',
        height: 'inherit',
        borderRadius: 0,
        color: '#AAB7B8',
        borderColor: '#AAB7B8',
        borderStyle: "dashed",
        borderWidth: 1
    },
    submit: {
        fontSize: 14,
        width: 150,
        padding: 10
    }
}));

function getStyles(name, personName, theme) {
    return {
        fontWeight:
            personName.indexOf(name) === -1
                ? theme.typography.fontWeightRegular
                : theme.typography.fontWeightMedium,
    };
}



const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};


export const ReviewLabel = styled.div`
    font-family: var(--Font1);
    font-size: 17px;
    font-weight: bold;
    ${props => props.marginBottom ? `margin-bottom: ${props.marginBottom};` : 'margin-bottom: 10px;'}
`

export const HerbImage = styled.div`
    width: 74px;
    height: 74px;
    background-repeat: none;
    background-size: cover;
    background-image: url(${props => props.theme.defaultHerbListIcon});      
    ${props => props.src ? `background-image: url(${props.src})` : `background-image: url(${props => props.theme.defaultHerbListIcon})`};


`

export const ReviewSection = styled.section`

`

export const PhotoGridItem = styled.div`
    position: relative;

    height: 70px;
    ${props => props.src ? `background-image: url(${props.src});` : "background: grey;"};
    background-size: cover;
    background-position: 50%;
    background-repeat: no-repeat;

`
export const AddPhotoGridItem = styled.div`
    height: 70px;
    background: #FAFAFA;

`

export const PhotoGrid = styled.div`
    position: relative;
    display: grid;
    grid-gap: 10px;
    grid-template-columns: repeat(auto-fit, 70px) ;
  
    height: 70px;

`


export const DividerLine = styled.div`
    width: 100%;
    height: 1px;
    background: #eee;
    margin-top: 10px;
    margin-bottom: 10px;
`

export const ManageFavoritesStyled = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    max-width: 1000px;
    margin: auto;

    padding-bottom: 100px;

    .custom-paragraph{
        margin-top: 0px;
        margin-bottom: 10px;
        font-size: 13px;
        color: #4D4D4D;
    }

    .review-footer{
        display: flex;
        flex-direction: row-reverse;
    }


    .herb-info{
        display: flex;
    }

    .herb-name{
        padding-left: 15px;
        font-family: var(--Font1);
        font-size: 17px;
    }

    .review-inputs-wrapper{
        display: grid;
        grid-template-columns: 1fr;
        grid-gap: 20px;
    }

    @media only screen and (max-width: ${BreakpointMobile + 'px'}){
        .favorite-list{
            padding: 10px;
        }

    }
`

function CreateHerbReview(props) {
    const classes = useStyles();
    let { errors, setErrors } = useContext(ErrorsContext)
    let pictureRef = useRef()
    let { user: currentUser, isTheUserLoggedIn } = useContext(AuthUserContext)

    let [submitting, setSubmitting] = useState(false)
    const theme = useTheme();

    let [herb, setHerb] = useState({
        name: "",
        pictures: [],
        _id: ""
    })

    let [ailments, setAilments] = useState([])
    let [loadingAilments, setLoadingAilments] = useState(false)
    let [loadingHerb, setLoadingHerb] = useState(false)

    let [review, setReview] = useState({
        remedyType: "Other",
        title: "",
        description: "",
        herb: "",
        pictures: [],
        used_for_ailments: []
    })
    let [usersReview, setUsersReview] = useState({
        _id: ""
    })

    let [lookingForExistingReview, setLookingForExistingReview] = useState(false)


    // START OF USE EFFECTS


    useEffect(() => {
        let isSubscribed = true;
        if (isSubscribed && props.search && props.search.id) {
            loadHerb()
        }

        return () => isSubscribed = false;

    }, [props.search && props.search.id, props.search.id !== herb._id])


    useEffect(() => {
        let isSubscribed = true;
        if (isSubscribed && herb._id !== "") {
            loadAilments()
        }

        return () => isSubscribed = false;

    }, [herb && herb._id])


    useEffect(() => {
        let isSubscribed = true;
        if (isSubscribed && herb._id && isTheUserLoggedIn) {
            loadReviewFromCurrentUser()
        }

        return () => isSubscribed = false;
    }, [isTheUserLoggedIn === true && herb._id !== ""])



    // END OF USE EFFECTS




    // START OF API CALLS

    const loadReviewFromCurrentUser = () => {
        setLookingForExistingReview(true)
        getReviewByHerbAndUserID(currentUser.id, herb._id)
            .then(res => {
                if (res.status === 200 && res.data) {

                    if (typeof window !== "undefined") {
                        window.scrollTo({ top: 0, behavior: 'smooth' })
                    }

                    setUsersReview(res.data)
                    navigate(`${SUBMITTED_HERB_REVIEW}?reviewid=${res.data._id}&herb=${herb._id}`)



                } else {
                    setLookingForExistingReview(false)

                }

            })
            .catch(err => {
                setLookingForExistingReview(false)

                throw err
            })
    }


    const loadAilments = () => {
        setLoadingAilments(true)
        getAilments("?minimumData=true&production=true")
            .then(res => {
                setAilments(res.data)
                setLoadingAilments(false)

            })
            .catch(err => {
                throw err
            })

    }



    const loadHerb = () => {
        setLoadingHerb(true)
        getHerbs(`?id=${props.search.id}`)
            .then(res => {
                if (res.status === 200 && res.data) {

                    setHerb(res.data)
                    let payload = { ...review, herb: res.data._id }
                    if (props.search && props.search.rating) {
                        payload.rating = Number(props.search.rating)
                    }
                    setReview(payload)
                    setLoadingHerb(false)


                }
            })
            .catch(err => {
                throw err
            })
    }

    const onSubmit = () => {
        setSubmitting(true)
        submitHerbReview(review)
            .then(res => {
                console.log(res, 'thi sis res')
                if (res.status >= 200) {
                    console.log('i hate you ')

                    loadReviewFromCurrentUser()

                }
            })
            .catch(err => {
                setSubmitting(false)

                setErrors(err.response.data)
                throw err
            })
    }

    // END OF API CALLS


    //START OF OTHER FUNCTIONS

    const handlePicture = event => {

        let updatedPictures = new Array(...review.pictures)

        new Compressor(event.target.files[0], {
            convertSize: 150,
            success(result) {
                blobToBase64(result, function (error, base64) {
                    let item = base64;
                    updatedPictures.push(item)
                    setReview({ ...review, pictures: updatedPictures })
                })
            },
            error(err) {
                console.log(err.message);
            }
        })
    };


    const handleOnChangeRating = (value) => {
        setReview({ ...review, rating: value })
    }


    const handleAilmentChange = event => {
        setReview({ ...review, used_for_ailments: event.target.value });
    };

    const handleRemovePhotoItem = (src) => {
        let picturesNow = new Array(...review.pictures)
        let filteredPictures = picturesNow.filter((pic) => pic !== src)

        setReview({ ...review, pictures: filteredPictures })
    }


    //END OF OTHER FUNCTIONS





    const hasSeoImage = herb && herb.pictures && herb.pictures[0] && herb.pictures[0].src ? true : false;


    // START OF RENDER ITEMS

    let remedyItems = remedyTypes.map((item, index) => {
        return <MenuItem value={item} key={index}>{item}</MenuItem>
    })

    let renderPictures = review.pictures.map((src, index) => {
        return (
            <PhotoGridItem key={index} src={src} >
                <IconButton onClick={() => handleRemovePhotoItem(src)} className={classes.photoGridRemove} size={"small"}>
                    <CloseIcon fontSize={"inherit"} />

                </IconButton>
            </PhotoGridItem>
        )
    })

    // END OF RENDER ITEMS








    return (
        <ManageFavoritesStyled>
            <PageHeaderTypeThree>Create Review</PageHeaderTypeThree>
            {loadingAilments || loadingHerb || lookingForExistingReview ? <LoadingContainer /> :
                <div className="review-inputs-wrapper">
                    <ReviewSection>

                        <div className="herb-info">
                            <HerbImage src={hasSeoImage ? herb.pictures[0].src : ""}>

                            </HerbImage>
                            <div className="herb-name">
                                {herb.name}
                            </div>


                        </div>
                    </ReviewSection>
                    <DividerLine />

                    <ReviewSection>
                        <ReviewLabel>Overall Rating</ReviewLabel>
                        <RatingInput onChange={handleOnChangeRating} value={review.rating} />
                        <div className="error-text">
                            {errors.rating ? errors.rating : ""}
                        </div>
                    </ReviewSection>

                    <DividerLine />


                    <ReviewSection>
                        <ReviewLabel>How did you use the herb?</ReviewLabel>
                        <FormControl

                            size={"small"}

                            variant="outlined" className={classes.formControl}>

                            <Select
                                disabled={submitting}
                                labelId="remedyTypeLabel"
                                id="remedyTypeSelect"
                                value={review.remedyType}
                                onChange={(e) => setReview({ ...review, remedyType: e.target.value })}
                            >
                                {remedyItems}

                            </Select>
                        </FormControl>
                    </ReviewSection>
                    <DividerLine />
                    <ReviewSection>
                        <ReviewLabel>What ailments has this herb helped you with?</ReviewLabel>
                        <FormControl fullWidth className={classes.formControl}>
                            <Select
                                labelId="herbs-select-label"
                                id="ailmentsCreateRemedySelect"
                                multiple
                                disabled={submitting}
                                variant="filled"
                                value={review.used_for_ailments}
                                onChange={handleAilmentChange}
                                input={<Input id="select-multiple-chip-tool" />}
                                renderValue={selected => (
                                    <div className={classes.chips}>
                                        {selected.map((value, index) => {
                                            let foundItem = ailments.find((ailment) => ailment._id === value)
                                            if (foundItem && foundItem.name) {
                                                return (<Chip key={index} label={foundItem.name} className={classes.chip} />)
                                            }

                                        }
                                        )}
                                    </div>
                                )}
                                MenuProps={MenuProps}
                            >

                                {ailments.map(ailment => (
                                    <MenuItem key={ailment._id} value={ailment._id}>
                                        <Checkbox checked={review.used_for_ailments.includes(ailment._id)} />
                                        <ListItemText primary={ailment.name} />
                                    </MenuItem>

                                ))}
                            </Select>
                            <FormHelperText error={errors.used_for_ailments ? true : false}>
                                {errors.used_for_ailments ? errors.used_for_ailments : ""}
                            </FormHelperText>
                        </FormControl>
                    </ReviewSection>
                    <DividerLine />

                    <ReviewSection>
                        <input ref={pictureRef} hidden type="file" onChange={(e) => handlePicture(e)}></input>

                        <ReviewLabel marginBottom={"0px"}>Add a photo</ReviewLabel>
                        <p className={"custom-paragraph"}>Other users find images more helpful than text alone.</p>
                        <PhotoGrid>
                            {review.pictures.length <= 5 ?
                                <IconButton disabled={submitting} onClick={() => pictureRef.current.click()} className={classes.addButton}>
                                    <AddIcon />
                                </IconButton> : ""}
                            {renderPictures}

                        </PhotoGrid>
                    </ReviewSection>
                    <DividerLine />

                    <ReviewSection>
                        <ReviewLabel>Add headline</ReviewLabel>
                        <TextField disabled={submitting} value={review.title} error={errors.title ? true : false} helperText={errors.description ? errors.title : ""} onChange={(e) => setReview({ ...review, title: e.target.value })} fullWidth size="small" id="headlineTextField" placeholder="What’s the most important thing to know?" variant="outlined" />
                    </ReviewSection>

                    <ReviewSection>
                        <ReviewLabel>Write your review</ReviewLabel>
                        <TextField disabled={submitting} value={review.description} error={errors.description ? true : false} helperText={errors.description ? errors.description : ""} onChange={(e) => setReview({ ...review, description: e.target.value })} fullWidth size="small" id="headlineTextField" placeholder="What did you like or dislike? Has this herb helped you with anything?" variant="outlined" />
                    </ReviewSection>
                    <footer className="review-footer">
                        <Button disabled={submitting} onClick={() => onSubmit()} className={classes.submit} disableElevation color="secondary" variant="contained">Submit{submitting ? 'ing' : ""} Review</Button>

                    </footer>

                    {errors.review ? <div className="error-text"> {errors.review} </div> : ""}

                </div>}
        </ManageFavoritesStyled >
    )
}


export default withLocation(CreateHerbReview)